<template>
    <div>
        <h1>Signup Dev Tools</h1>
        <ul>
            <li>
                <router-link :to="{ path: 'market-links/'}" append>
                    Market Links
                </router-link>
            </li>
        </ul>
    </div>
</template>
<script>
/* istanbul ignore file */
export default {};
</script>
